import { useSnapshot } from 'valtio'
import { CompanyTable } from './components/CompanyTable'
import { Onboarding } from './components/Onboarding'
import { Toaster } from '@/components/ui/sonner'
import { store, actions } from './store'
import './App.css'

function App() {
  const snap = useSnapshot(store)

  const handleCloseOnboarding = () => {
    actions.setShowOnboarding(false)
    if (!snap.onboardingCompleted) {
      actions.completeOnboarding()
    }
  }

  return (
    <div className="min-h-screen bg-background">
      <Onboarding open={snap.showOnboarding} onClose={handleCloseOnboarding} />
      <CompanyTable />
      <Toaster />
    </div>
  )
}

export default App
